import React from "react";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  console.log("ErrorBoundary:", error);
  return (
    <div className="error-boundary" role="alert">
      <div className="error-boundary__content">
        <h1 className="error-boundary__title">Oops!</h1>
        <p className="error-boundary__copy">
          Something seems to have gone wrong, hit a quick refresh to get back
          on-track!
        </p>
        <button className="button button--dark" onClick={resetErrorBoundary}>
          Refresh
        </button>
      </div>
      <img
        className="error-boundary__image"
        src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/error-hitchhiker.jpg"
        alt="error image"
      />
    </div>
  );
};

export default ErrorFallback;
